<template>
  <div class="container">
    <van-sticky>
      <PublicHeader :totalName="$t('c2c').chat" />
      <!-- 顶部 -->
      <div class="top">
        <!-- tab切换 -->
        <div class="tabs"><span v-for="(item, index) in tabs" :key="`tab${index}`" :class="active == item.value ? 'active' : ''" @click="changeTab(item.value)">{{ item.name }}</span></div>
      </div>
    </van-sticky>
    <!-- 列表 -->
    <div class="orderList">
      <van-list v-model="loading" :finished="finished" :loading-text="$t('public').loadingText" @load="getOrderList" :immediate-check="false">
        <div class="item" v-for="(dItem, dIndex) in oList" :key="`chat${dIndex}`" @click="$router.push({ name: 'Chat', query: { id: dItem.ctcOrderId } })">
          <div class="logo">{{ dItem.vendorName.substring(0, 1) }}</div>
          <div class="right">
            <!-- 名称 -->
            <div class="name"><span>{{ dItem.vendorName }}</span> {{ dItem.talkCreateTime | getLocalTime }}</div>
            <!-- 内容 -->
            <div class="txt">{{ dItem.talkContentType == 1 ? dItem.talkContent : dItem.talkContentType == 2 ?
              $t('c2c').picture :
              ''}}</div>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>

<script>
import PublicHeader from '@/components/publicHeader'
import chatApi from '@/api/chat'

export default {
  components: {
    PublicHeader
  },
  data() {
    return {
      active: "",
      tabs: [{
        "name": this.$t('c2c').all,
        "value": ""
      }, {
        "name": this.$t('c2c').inprogress,
        "value": "1"
      },
      ],
      isRun: false,
      loading: false,
      finished: false,
      parms: {
        pageNum: 1,
        pageSize: 15,
      },
      oList: [],
    }
  },
  mounted() {
    this.getOrderList()
  },
  methods: {
    //切换
    changeTab(val) {
      this.active = val
      this.refreshOrderList()
    },
    //刷新获取订单列表
    refreshOrderList() {
      this.oList = []
      this.parms.pageNum = 1
      this.finished = false;
      this.getOrderList()
    },
    // 获取订单列表
    async getOrderList() {
      if (this.isRun) return
      this.isRun = true
      this.parms.status = this.active
      const res = await chatApi.getTalkItemGroupList(this.parms)
      this.oList.push(...res.rows);
      this.isRun = false
      this.parms.pageNum++
      // 加载状态结束
      this.loading = false;
      // 数据全部加载完成
      if (this.oList.length >= res.total)
        this.finished = true;
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  background: var(--background_color);

  .top {
    padding-top: 50px;
    width: 100%;
    background: var(--background_color);

    .tabs {
      padding: 0 15px;
      font-size: 14px;
      font-weight: bold;
      color: var(--ntext_color);
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;

      span {
        padding: 12px 0;
        margin-right: 20px;
      }

      .active {
        color: var(--primary_color);
        padding-bottom: 10px;
        border-bottom: 2px solid var(--primary_color);
      }
    }
  }

  .orderList {
    margin-bottom: 30px;

    .item {
      padding: 15px;
      color: var(--text_color);
      font-size: 13px;
      border-bottom: 1px solid var(--info_color);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .logo {
        font-size: 15px;
        width: 30px;
        height: 30px;
        background: var(--text_color);
        color: var(--background_color);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .right {
        margin-left: 10px;
        width: 300px;

        .name {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          color: var(--ntext_color);

          span {
            max-width: 170px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            color: var(--text_color);
          }
        }

        .txt {
          margin-top: 5px;
          max-width: 300px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          font-size: 12px;
          color: var(--ntext_color);
        }
      }
    }
  }
}
</style>
